module.exports = __webpack_public_path__ + "static/media/img_header_logo.916a9e80.webp";